import { createSelectorCreator } from 'reselect';
import _identity from 'lodash/identity';
var selectorWithoutMemoize = createSelectorCreator(_identity);
export default selectorWithoutMemoize;